import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { encodeText, decodeText } from '@projects/adir/src/app/utils/adir-utils';
@Injectable()
export class TextEncoderInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // Clone and encode the request body if it exists
    let encodedRequest = request;
    if (request.body) {
      try {
        if (request.body instanceof File) {
          return next.handle(request);
        }

        const bodyCopy = JSON.parse(JSON.stringify(request.body));
        const encodedBody = this.encodeRequestBody(bodyCopy);
        encodedRequest = request.clone({ body: encodedBody });
      } catch (error) {
        console.error('Error encoding request body:', error);
      }
    }

    // Process the response
    return next.handle(encodedRequest);
  }

  private encodeRequestBody(body: any): any {
    if (!body) return body;

    // Preserve the same type as the original request body
    if (Array.isArray(body)) {
      // Handle arrays
      const clonedBody = [...body];
      this.processObject(clonedBody, true);
      return clonedBody;
    } else if (typeof body === 'object') {
      // Handle objects
      const clonedBody = { ...body };
      this.processObject(clonedBody, true);
      return clonedBody;
    } else if (typeof body === 'string') {
      // Handle primitive string values directly
      return encodeText(body);
    } else {
      // Return other primitive values as is
      return body;
    }
  }

  private processObject(obj: any, encode: boolean): void {
    if (!obj) {
      return;
    }

    if (typeof obj !== 'object') {
      return;
    }

    if (Array.isArray(obj)) {
      for (let i = 0; i < obj.length; i++) {
        this.processValue(obj, i, obj[i], encode);
      }
      return;
    }

    Object.keys(obj).forEach((key) => {
      this.processValue(obj, key, obj[key], encode);
    });
  }

  private processValue(container: any, key: string | number, value: any, encode: boolean): void {
    // Skip null/undefined values
    if (!value) {
      return;
    }

    if (typeof value === 'string') {
      container[key] = encode ? encodeText(value) : decodeText(value);
    } else if (typeof value === 'object') {
      this.processObject(value, encode);
    }
  }
}
